module.exports = __webpack_public_path__ + "img/pigment-main-banner.b354f69e.png";